import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadio = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	stroke: "var(--control-rest-border, #869496)",
	fill: "var(--control-rest-bg, none)",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 23,
		height: 23,
		rx: "var(--radio-radius, 7.5)",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRadio;
